import { React, useContext } from "react";
import RenderMarkups from "../shared/RenderMarkups";
import { GlobalContext } from "../state/GlobalContext";


export default function IncorrectAge(){
    const { state, setState } = useContext(GlobalContext);

    return (
        <div className="row">
            <div className="col">
                <div className="incorrect-age-wrapper">
                    <div className="heading-wrapper" dangerouslySetInnerHTML={RenderMarkups(state.testData.incorrect_age_step.heading)}></div>
                    <div className="desc-wrapper" dangerouslySetInnerHTML={RenderMarkups(state.testData.incorrect_age_step.desc)}></div>
                    <a title={state.testData.incorrect_age_step.button_label} href={state.testData.incorrect_age_step.button_link}>{state.testData.incorrect_age_step.button_label}</a>
                </div>
            </div>
        </div>
    )
}